import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';
import { PreloadScene } from './scenes/PreloadScene';
import type { GameSceneData } from './scenes/GameScene';

export type { GameSceneData };

export function createNganyaGame(
  parent: HTMLElement,
  width: number,
  height: number,
): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width,
    height,
    backgroundColor: '#1a3a28',
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width,
      height,
    },
    render: {
      antialias: true,
      pixelArt: false,
      powerPreference: 'high-performance',
    },
    audio: {
      disableWebAudio: false,
    },
    scene: [BootScene, PreloadScene, GameScene],
    banner: false,
  });
}

export function startRun(game: Phaser.Game, data: GameSceneData): void {
  if (game.scene.isActive('GameScene') || game.scene.isPaused('GameScene')) {
    game.scene.stop('GameScene');
  }
  game.scene.start('GameScene', data);
}
